import React, { Component } from 'react';
import * as style from './mapRegion.module.scss';

class SelectableRegion extends Component {
  render() {
    const selectedClass = this.props.selected ? style.regionSelected : '';
    return this.props.type === 'path' ? (
      <path
        d={this.props.d}
        id={`climateMapRegion${this.props.index}`}
        className={selectedClass}
        ref={el => {
          if (this.props.mini) {
            return;
          }
          this.props.getRegionRef(el, this.props.index);
        }}
      />
    ) : (
      <polygon
        points={this.props.points}
        id={`climateMapRegion${this.props.index}`}
        className={selectedClass}
        ref={el => {
          if (this.props.mini) {
            return;
          }
          this.props.getRegionRef(el, this.props.index);
        }}
      />
    );
  }
}

export default SelectableRegion;
